<template>
  <!-- 编辑配置信息弹窗 -->
  <div id="addDeviceTem">
    <el-form ref="addDevicePop" class="addDevicePop" :inline="true" :model="addBasicinfo" :rules="rules" label-position="right" label-width="150px">
      <el-row :gutter="40">
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.SN')" prop="deviceSn">
            <!-- <el-autocomplete v-model="addBasicinfo.deviceSn" class="inline-input" style="width: 200px" :placeholder="$t('BondOrUpdateDevice.PleaseEnterSN')" :fetch-suggestions="querySearch" :trigger-on-focus="false" :disabled="editing" @select="handleSelectSN" /> -->
            <el-input v-model="addBasicinfo.deviceSn" :placeholder="$t('BondOrUpdateDevice.FindSN')" @input="snChange(addBasicinfo.deviceSn)" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.MCUID')" prop="mcuId">
            <el-input v-model="addBasicinfo.mcuId" disabled maxlength="6" style="width: 200px" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('dashboard.DeviceName')" prop="deviceName">
            <el-input v-model.trim="addBasicinfo.deviceName" :placeholder="$t('BondOrUpdateDevice.PleaseEnterAName')" @input="change($event)" />
          </el-form-item>
        </el-col>
        <el-col v-if="!$store.state.isAdmin" :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.Passcode')" prop="passcode">
            <!--激活码-->
            <el-input v-model="addBasicinfo.passcode" :placeholder="$t('BondOrUpdateDevice.EnterNumbers')" @input="change($event)" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.Model')" class="redStart" prop="batteryModel">
            <!-- 电池型号 -->
            <el-cascader v-if="!showBatteryModel" v-model="batteryBrandModel" :options="options2" :placeholder="$t('BondOrUpdateDevice.SelectBattery')" :show-all-levels="true" style="width: 200px" @change="batteryModelChange" />
            <el-cascader v-else v-model="batteryBrandModel" :options="options2" :placeholder="addBasicinfo.batteryBrand + '/' + addBasicinfo.batteryModel" :show-all-levels="true" style="width: 200px" @change="batteryModelChange" />
            <p v-show="isShowBatteryModelWarning" class="redWarningFont">{{ $t('BondOrUpdateDevice.SelectBattery') }}</p>
          </el-form-item>
        </el-col>

        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col c520">
          <el-form-item :label="$t('AllDevices.Type')">
            <el-radio v-model="addBasicinfo.c520" :label="2" @change="changeC520(2)">C5</el-radio>
            <el-radio v-model="addBasicinfo.c520" :label="1" @change="changeC520(1)">C20</el-radio>
            <el-radio v-model="addBasicinfo.c520" :label="3" @change="changeC520(3)">C6</el-radio>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <!--容量-->
          <el-form-item :label="$t('BondOrUpdateDevice.Capacity')" prop="batteryTotalah">
            <el-input v-model="addBasicinfo.batteryTotalah" :placeholder="$t('BondOrUpdateDevice.EnterBatteryCapacity')" @input="change($event)" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('basicinfo.SystemVoltage')" prop="batterySystemVolt">
            <!--系统电压-->
            <el-input v-model="addBasicinfo.batterySystemVolt" :placeholder="$t('BondOrUpdateDevice.PleaseSelectOperatingVoltage')" @input="change($event)" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.OwnedCompany')" class="redStart" prop="owncompany">
            <!--归属公司-->
            <el-select v-model="addBasicinfo.company" :disabled="showBatteryModel" :placeholder="$t('AllDevices.companyName')" class="filter-item" clearable filterable @change="companySelect">
              <el-option v-for="(item,index) in companyOptions" :key="index" :label="item.companyName" :value="item.companyId" />
            </el-select>
            <p v-show="isShowOwnCompany" class="redWarningFont">{{ $t('lease.Cannotbeblanked2') }}</p>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.Machine')+$t('adminView.Brand')">
            <!--品牌-->
            <el-autocomplete v-model="addBasicinfo.mechBrand" class="inline-input" :fetch-suggestions="queryMechBrand" :placeholder="$t('BondOrUpdateDevice.Machine')+$t('adminView.Brand')" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.Machine')+$t('adminView.Type')">
            <!--类型-->
            <el-select v-model="addBasicinfo.mechType" :placeholder="$t('BondOrUpdateDevice.Machine')+$t('adminView.Type')" class="filter-item" clearable filterable>
              <el-option v-for="(item,index) in machineTypeOptions" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 机器型号 -->
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.Machine')+$t('adminView.Model2')">
            <el-input v-model="addBasicinfo.mechModel" :placeholder="$t('BondOrUpdateDevice.Machine')+$t('adminView.Model2')" @input="change($event)" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col cellNumber">
          <el-form-item :label="$t('AllDevices.cellNumber')" prop="cell">
            <el-input v-model="addBasicinfo.cell" :placeholder="$t('warningSet.Pleaseenter')" @input="change($event)" />
            <i class="el-icon-question" @mouseover="isShowCellNumPop=true" @mouseout="isShowCellNumPop=false" />
          </el-form-item>
          <div v-if="isShowCellNumPop" class="cellNumberInfoPop">
            <p>{{ $t('allDeviceDetail.cellNumberInfo') }}</p>
          </div>
        </el-col>
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col cellNumber">
          <el-form-item :label="$t('dashboard.SiteName')">
            <el-autocomplete v-model="addBasicinfo.site" class="inline-input" :fetch-suggestions="querySearchCity" :placeholder="$t('dashboard.SiteName')" @select="handleSelect" />
          </el-form-item>
        </el-col>
        <el-col v-if="activeDeviceType=='a'||activeDeviceType=='e'" :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('adminView.battery')+ ' SN'">
            <el-input v-model="addBasicinfo.batterySn" :placeholder="$t('adminView.battery')+ ' SN'" @input="change($event)" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col fullChargeTime">
          <el-form-item :label="$t('BondOrUpdateDevice.fullChargeTime')" prop="fullChargeTime">
            <el-input v-model="addBasicinfo.fullChargeTime" :placeholder="$t('warningSet.Pleaseenter')" @input="change($event)" />
            <span>{{ $t('dataAndTime.Min') }}</span>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('AllDevices.GPS')" prop="LocatedOrNot">
            <el-switch v-model="LocatedOrNot" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" @change="change($event)" />
          </el-form-item>
        </el-col>
        <el-col v-if="activeDeviceType=='a'" :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('allDeviceDetail.RemainingTime')" prop="LocatedOrNot">
            <el-switch v-model="addBasicinfo.showAvailableTime" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" @change="change($event)" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('AllDevices.IgnitionReport')" prop="hourMeterStatus">
            <el-switch v-model="addBasicinfo.hourMeterStatus" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" @change="change($event)" />
          </el-form-item>
        </el-col>
        <el-col v-if="addBasicinfo.hourMeterStatus" :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('AllDevices.IgnitionVoltage')" prop="openIgnitionVol">
            <el-input v-model="addBasicinfo.openIgnitionVol" :placeholder="$t('warningSet.Pleaseenter')" @input="change($event)" />
          </el-form-item>
        </el-col>
        <el-col v-if="addBasicinfo.hourMeterStatus" :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('AllDevices.UseVoltageTh')" prop="workHourmeterVol">
            <el-input v-model="addBasicinfo.workHourmeterVol" :placeholder="$t('warningSet.Pleaseenter')" @input="change($event)" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
          <el-form-item :label="$t('AllDevices.HalfV')">
            <el-switch v-model="addBasicinfo.halfV" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" @change="change($event)" />
          </el-form-item>
        </el-col>
        <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item style="text-align: end;">
            <el-button @click="closePop">{{ $t('button.Cancel') }}</el-button>
            <el-button :disabled="disabledSubmit" class="filter-item" type="primary" @click="submitBindDeviceModel('addDevicePop')">{{ $t('button.Submit') }}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { addDeviceBindBase, getLastOne, deviceBattery, addDeviceBindConfig, updateDeviceBindBase, querySN, getLastMessageBootReq, getCompanySiteList, getLastYhubConfig } from '@/api/allDevice'
import i18n from '@/i18n'
import { updatePushMsgUser, getGroupCompanyUserList } from '@/api/warning'

var checkNumber = (rule, value, callback) => {
  setTimeout(() => {
    if (value && !/^[0-9]*[1-9][0-9]*$/.test(value)) {
      callback(new Error(i18n.t('AllDevices.mustInt')))
    } else {
      callback()
    }
  }, 1000)
}
export default {
  name: 'DashboardAdmin',
  components: {
  },
  props: {
    companyOptions: {
      type: Array,
      default: () => []
    },
    options2: {
      type: Array,
      default: () => []
    },
    machineTypeOptions: {// 设备类型
      type: Array,
      default: () => []
    },
    activeDeviceType: {
      type: String,
      default: ''
    },
    isShowAddDevicePop: {
      type: Boolean,
      default: false
    },
    canFuntion: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      LocatedOrNot: false, // 是否打开定位
      batteryModelObj: {},
      isShowBatteryModelWarning: false,
      addBasicinfo: {
        mcuId: '',
        cell: 1,
        c520: '1',
        deviceSn: '',
        deviceName: '',
        canFuntion: '0',
        locationSample: '60',
        batterySystemVolt: null,
        batteryTotalah: null,
        supportWaterlevel: null,
        ledSetting: null,
        sensorType: null,
        hallDirection: null,
        motionTrack: null,
        supportRelaycontrol: null,
        batteryId: 2,
        batteryBrand: 'Trojan',
        batteryModel: 'T105',
        configFrom: null,
        configVersion: null,
        gprsApnName: '263.cs101',
        hallSensorRange: 1,
        voltClass: 1,
        hourMeterStatus: false,
        openIgnitionVol: null,
        workHourmeterVol: null,
        halfV: false,
        site: '',
        fullChargeTime: 30
      },
      batteryBrandModel: [],
      bindDeviceTypeArr: [], // sn绑定的设备类型
      firstAdd: true, // 首次新增，false：已存在，添加其他类型
      showBatteryModel: false, // 是否展示电池型号默认值
      isShowOwnCompany: false,
      machineBrandOptions: [], // 设备品牌
      allCity: [],
      oldbatterySystemVolt: '',
      oldbatteryTotalah: '',

      batteryCascader: [],
      isShowHallDetail: false,
      disabledSubmit: true,
      noneConfig: false,
      isShowConfigStatu: false,
      configStatuPop: false,
      nowAndNewConfigData: [],
      loadEditPop: false,
      isShowCellNumPop: false,
      isShowMustIntWarn: false
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    },
    rules() {
      return {
        deviceName: [{ required: true, message: i18n.t('allDeviceDetail.DeviceNameCannotEmpty'), trigger: 'blur' }], // 设备名称不能为空
        deviceSn: [{ required: true, message: i18n.t('BondOrUpdateDevice.SNNotFound'), trigger: 'blur' }], // 序列号不能为空
        mcuId: [{ required: true, message: i18n.t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        passcode: [{ required: true, message: i18n.t('BondOrUpdateDevice.IncorrectPasscode'), trigger: 'blur' }], // 激活码不能为空
        batteryTotalah: [{ required: true, message: i18n.t('BondOrUpdateDevice.EnterBatteryCapacity'), trigger: 'blur' }], // 容量不能为空
        batterySystemVolt: [{ required: true, message: i18n.t('BondOrUpdateDevice.PleaseSelectOperatingVoltage'), trigger: 'blur' }], // 系统电压不能为空
        cell: [{ required: true, message: i18n.t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        fullChargeTime: [{ validator: checkNumber, trigger: 'blur' }]
        // owncompany: [{ required: true, message: '归属公司不能为空', trigger: 'change' }]
      }
    }
  },
  watch: {
    isShowAddDevicePop: {
      handler(newValue, oldValue) {
        if (!this.isShowAddDevicePop) {
          this.addBasicinfo = {
            mcuId: '',
            cell: 1,
            c520: '1',
            deviceSn: '',
            deviceName: '',
            canFuntion: '0',
            locationSample: '60',
            batterySystemVolt: null,
            batteryTotalah: null,
            supportWaterlevel: null,
            ledSetting: null,
            sensorType: null,
            hallDirection: null,
            motionTrack: null,
            supportRelaycontrol: null,
            batteryId: 2,
            batteryBrand: 'Trojan',
            batteryModel: 'T105',
            configFrom: null,
            configVersion: null,
            gprsApnName: '263.cs101',
            hallSensorRange: 1,
            voltClass: 1,
            hourMeterStatus: false,
            openIgnitionVol: null,
            workHourmeterVol: null,
            halfV: false,
            site: '',
            fullChargeTime: 30,
            canopenBaudrate: 2,
            nodeID: 85
          }
          this.batteryBrandModel = []
        } else {
          this.$nextTick(() => {
            this.$refs.addDevicePop.clearValidate()// 等弹窗里的form表单的dom渲染完在执行this.$refs.staffForm.clearValidate(),移除该表单项的校验结果
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.getCity()
  },
  created() { },
  methods: {
    snChange(val) { // 绑定设备弹窗--改变sn
      if (val.length >= 11 || (val.length == 10 && val[0] == 'P')) {
        if (this.addBasicinfo.deviceSn) {
          this.addBasicinfo.deviceSn = this.addBasicinfo.deviceSn.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
        }
        querySN({ sn: this.addBasicinfo.deviceSn }).then((res) => {
          if (res.resultCode == 1001) {
            if (!res.resultModel) {
              this.disabledSubmit = true
              this.$notify({
                title: '',
                message: i18n.t('AllDevices.enterCorrectsn'),
                type: 'warning',
                duration: 3000
              })
              this.showBatteryModel = false
            } else {
              // getLastMessageBootReq({ mcuId: res.resultModel.yhubMcu }).then((response) => {
              //   // 查找版本号
              //   if (response.resultCode == 1001) {
              //     if (response.resultModel && response.resultModel.fwVersion) {
              //       this.fwversion = response.resultModel.fwVersion
              //     }
              //   }
              // })
              this.$set(this.addBasicinfo, 'mcuId', res.resultModel.yhubMcu)
              this.addBasicinfo.c520 = 1
              if (res.resultModel.bindInfoList.length == 0) { // 未绑定
                this.disabledSubmit = false
                this.addBasicinfo.bindInfoList = []
                this.showBatteryModel = false
              } else { // 已绑定
                this.firstAdd = false
                this.addBasicinfo.bindInfoList = res.resultModel.bindInfoList
                var companyIds = [] // 当前公司及子公司id的集合
                var types = [] // 已绑定的类型的集合
                this.companyOptions.forEach((v) => {
                  companyIds.push(v.companyId)
                })
                // if(res.resultModel.bindInfoList.length>1){//一定绑定了kisae
                res.resultModel.bindInfoList.forEach((v) => {
                  if (v.deviceType.indexOf(',') > -1) {
                    var a = v.deviceType.split(',')
                    types = types.concat(a)
                  } else {
                    types.push(v.deviceType)
                  }
                })
                // }
                this.bindDeviceTypeArr = types
                this.addBasicinfo.bindId = res.resultModel.bindInfoList[0].id
                // console.log('types', types)
                var typeZh = ''
                if (types.indexOf('a') > -1 || types.indexOf('e') > -1) {
                  typeZh = i18n.t('AllDevices.BatteryMonitor')
                } else if (types.indexOf('c') > -1) {
                  typeZh = i18n.t('AllDevices.charger')
                } else if (types.indexOf('k') > -1) {
                  typeZh = 'Kisae'
                } else if (types.indexOf('i') > -1) {
                  typeZh = 'EVE_BMS'
                } else if (types.indexOf('j') > -1) {
                  typeZh = 'EVE_F477'
                }
                this.$notify({
                  title: '',
                  message: i18n.t('AllDevices.hadBindWarn').replace('$', typeZh),
                  type: 'warning',
                  duration: 4000
                })
                this.disabledSubmit = false
                this.addBasicinfo.company = res.resultModel.bindInfoList[0].companyId
                this.addBasicinfo.cell = res.resultModel.bindInfoList[0].cell
                this.addBasicinfo.deviceName = res.resultModel.bindInfoList[0].deviceName
                // this.addBasicinfo.deviceSn = res.resultModel.bindInfoList[0].deviceSn
                this.addBasicinfo.batteryModel = res.resultModel.bindInfoList[0].batteryModel
                this.addBasicinfo.batteryId = res.resultModel.bindInfoList[0].batteryId == 0 ? 2 : res.resultModel.bindInfoList[0].batteryId
                this.addBasicinfo.batteryModel = res.resultModel.bindInfoList[0].batteryModel
                this.addBasicinfo.batteryBrand = res.resultModel.bindInfoList[0].batteryBrand
                this.addBasicinfo.batteryTotalah = res.resultModel.bindInfoList[0].batteryCapacity
                this.addBasicinfo.batterySystemVolt = res.resultModel.bindInfoList[0].batteryVoltage
                this.LocatedOrNot = res.resultModel.bindInfoList[0].locationStatus == 1
                this.addBasicinfo.showAvailableTime = res.resultModel.bindInfoList[0].showAvailableTime == 1
                if (res.resultModel.lastYhubConfig && res.resultModel.lastYhubConfig.batterySystemVolt) {
                  this.oldbatterySystemVolt = this.addBasicinfo.batterySystemVolt = res.resultModel.lastYhubConfig.batterySystemVolt > 100 ? res.resultModel.lastYhubConfig.batterySystemVolt / 100 : res.resultModel.lastYhubConfig.batterySystemVolt
                } else {
                  this.addBasicinfo.batteryVoltage = '24'
                }
                if (res.resultModel.lastYhubConfig && res.resultModel.lastYhubConfig.batteryTotalah) {
                  this.oldbatteryTotalah = this.addBasicinfo.batteryTotalah = res.resultModel.lastYhubConfig.batteryTotalah > 1000 ? Math.round(res.resultModel.lastYhubConfig.batteryTotalah / 100) : res.resultModel.lastYhubConfig.batteryTotalah
                } else {
                  this.addBasicinfo.batteryCapacity = '225'
                }
                // deviceBattery({ id: this.addBasicinfo.batteryId }).then(response => {
                //   var c520 = this.addBasicinfo.batteryTotalah / 100 == response.resultModel.batteryAhC5 ? 5 : 20
                //   this.$set(this.addBasicinfo, 'c520', c520)
                // })
                console.log('addBasicinfo:::', this.addBasicinfo)
                this.$forceUpdate()
                this.showBatteryModel = true
              }
              // this.bindDeviceTypeArr = [this.activeDeviceType]
              deviceBattery({ id: this.addBasicinfo.batteryId }).then(resp => {
                if (resp.resultCode == 1001 && resp.resultModel) {
                  this.batteryModelObj.batteryAh = resp.resultModel.batteryAh
                  this.batteryModelObj.batteryAhC5 = resp.resultModel.batteryAhC5
                  if (res.resultModel.bindInfoList.length == 0) this.addBasicinfo.batteryTotalah = res.resultModel.batteryAh
                  // console.log(this.addBasicinfo)
                }
              })
              getLastYhubConfig({ mcuId: res.resultModel.yhubMcu }).then((res) => {
                if (res.resultCode == 1001) {
                  if (res.resultModel) {
                    var c520 = res.resultModel.nominalCapacity ? res.resultModel.nominalCapacity : 1
                    this.$set(this.addBasicinfo, 'c520', c520)
                  }
                }
              })
              if (!this.disabledSubmit) {
                getLastOne({ mcuId: res.resultModel.yhubMcu }).then((res) => {
                  if (res.resultCode == 1001) {
                    if (!res.resultModel || !res.resultModel.jsonData || !JSON.parse(res.resultModel.jsonData).gprs_apn_name) {
                      this.$message({
                        type: 'error',
                        message: i18n.t('AllDevices.NoNetworkInfo')// '未找到联网信息，无法绑定，请联系管理员'
                      })
                      this.disabledSubmit = true
                      return
                    }
                    this.noneConfig = false
                    var jsonData = JSON.parse(res.resultModel.jsonData)
                    console.log(jsonData)
                    this.addBasicinfo.locationSample = (!jsonData.location_sample || jsonData.location_sample < 30) ? 60 : jsonData.location_sample
                    this.addBasicinfo.supportWaterlevel = jsonData.is_support_waterlevel == true ? 1 : 0
                    this.addBasicinfo.ledSetting = jsonData.led_setting
                    this.addBasicinfo.sensorType = jsonData.sensor_type
                    this.addBasicinfo.hallDirection = jsonData.hall_direction
                    this.addBasicinfo.hallSensorRange = jsonData.hall_sensor_range
                    this.addBasicinfo.voltClass = jsonData.volt_class
                    this.addBasicinfo.extralFuntion = jsonData.extral_funtion
                    this.addBasicinfo.supportRelaycontrol = jsonData.is_support_relaycontrol == true ? 1 : 0
                    this.addBasicinfo.gprsApnName = jsonData.gprs_apn_name
                    this.addBasicinfo.configFrom = jsonData.config_from
                    this.addBasicinfo.configVersion = jsonData.config_version
                    this.addBasicinfo.canopenBaudrate = jsonData.canopen_baudrate ? jsonData.canopen_baudrate : 2
                    this.addBasicinfo.nodeID = jsonData.node_id ? jsonData.node_id : 85
                  }
                })
              }
            }
          }
        })
      }
    },
    changeC520(val) { // 绑定设备弹窗--改变c5/c20
      this.$forceUpdate()
      // if (this.batteryModelObj.batteryAh) {
      //   this.addBasicinfo.batteryTotalah = val == 2 ? this.batteryModelObj.batteryAhC5 : this.batteryModelObj.batteryAh
      // }
      switch (val) {
        case 1:this.addBasicinfo.batteryTotalah = this.batteryModelObj.batteryAh; break
        case 2:this.addBasicinfo.batteryTotalah = this.batteryModelObj.batteryAhC5; break
        case 3:this.addBasicinfo.batteryTotalah = this.batteryModelObj.batteryAhC6; break
      }
    },
    batteryModelChange(value) { // 绑定设备弹窗--电池型号选中
      console.log('batteryBrandModel--', this.batteryBrandModel)
      if (!this.batteryBrandModel) return
      this.addBasicinfo.c520 = 1
      this.batteryModelObj = value[1]
      if (!value[1].batteryAhC5) { this.disabledC5 = true } else { this.disabledC5 = false }
      // this.addBasicinfo.batteryTotalah = this.addBasicinfo.c520 == 2 ? value[1].batteryAhC5 : value[1].batteryAh
      switch (this.addBasicinfo.c520) {
        case 1:this.addBasicinfo.batteryTotalah = value[1].batteryAh; break
        case 2:this.addBasicinfo.batteryTotalah = value[1].batteryAhC5; break
        case 3:this.addBasicinfo.batteryTotalah = value[1].batteryAhC6; break
      }
      this.addBasicinfo.batteryId = value[1].id
      this.addBasicinfo.batteryBrand = value[1].batteryBrand
      this.addBasicinfo.batteryModel = value[1].batteryModel
      this.addBasicinfo.batterySystemVolt = value[1].batteryVoltage || 24
      this.isShowBatteryModelWarning = false
    },
    companySelect(query) { // 绑定设备弹窗--公司信息选中
      for (const key2 in this.options) {
        const company = this.options[key2]
        if (query === company.id) {
          this.addBasicinfo.companyName = company.companyName
          this.addBasicinfo.companyId = company.id
          break
        }
      }
      this.isShowOwnCompany = false
    },
    queryMechBrand(queryString, cb) {
      var machineBrandOptions = this.machineBrandOptions
      var results = queryString ? machineBrandOptions.filter(this.createFilter(queryString)) : machineBrandOptions
      cb(results)
    },
    closePop(val) { // 绑定设备弹窗--取消
      this.showBatteryModel = false
      for (var attr in this.addBasicinfo) this.addBasicinfo[attr] = ''
      this.$nextTick(() => {
        this.$refs.addDevicePop.clearValidate()// 等弹窗里的form表单的dom渲染完在执行this.$refs.staffForm.clearValidate(),移除该表单项的校验结果
      })
      this.$emit('closeAddPopClick', val)
    },
    decimalToBinary(num, digits) { // 十进制转二进制  digits:代表传过来的是几位数，避免用<10判断出错，如：01 本应该转成8位，却转成了4位
      var myNum = num
      var b = []
      while (1) {
        var remainder = num % 2
        b.unshift(remainder)
        num = parseInt(num / 2)
        if (num == 0) break
      }
      var len
      if (!digits || digits == 1) {
        len = 4 - b.length
        for (var i = 0; i < len; i++) {
          b.unshift(0)
        }
      // } else if (myNum >= 10 && myNum < 100) {
      } else if (digits == 2) {
        len = 8 - b.length
        for (var j = 0; j < len; j++) {
          b.unshift(0)
        }
      }
      return b.reverse()
    },
    binaryToDecimal(arr) { // 二进制转十进制
      var a = []
      var allZero = arr.every(m => { return m == 0 })
      if (allZero) {
        c = 0
      } else {
        arr.forEach((v, i) => {
          var end = arr.slice(i)
          // 如果v=1,并且v后面没有1了，则a等于v及其之前的数。如：arr=[0,1,1,1,1,0,0,0] => a=[0,1,1,1,1]
          if (v == 1 && end.indexOf(1) > -1)a = arr.slice(0, i + 1)
        })
        var b = a.reverse().join('')
        var c = parseInt(b, 2).toString(10)
      }
      return c
    },
    getCity() { // 获取已有的地址1
      this.allCity = []
      getCompanySiteList().then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.forEach(v => {
          this.allCity.push({ value: v })
        })
      })
    },
    submitBindDeviceModel(formName) { // 新增绑定设备弹窗--提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var param = {
            id: this.addBasicinfo.bindId || '',
            batteryId: this.addBasicinfo.batteryId == 0 ? 2 : this.addBasicinfo.batteryId,
            mechId: 1,
            mcuId: this.addBasicinfo.mcuId,
            companyName: this.addBasicinfo.companyName,
            companyId: this.addBasicinfo.company,
            deviceName: this.addBasicinfo.deviceName,
            deviceSn: this.addBasicinfo.deviceSn,
            batteryModel: this.addBasicinfo.batteryModel,
            deviceType: this.activeDeviceType,
            batterySystemVolt: this.addBasicinfo.batterySystemVolt,
            batteryTotalah: this.addBasicinfo.batteryTotalah * 100,
            yhubPc: this.addBasicinfo.passcode || '',
            locationStatus: '',
            cell: this.addBasicinfo.cell,
            openIgnitionVol: this.addBasicinfo.openIgnitionVol,
            workHourmeterVol: this.addBasicinfo.workHourmeterVol,
            showAvailableTime: '',
            machineBrand: this.addBasicinfo.mechBrand,
            machineType: this.addBasicinfo.mechType,
            machineModel: this.addBasicinfo.mechModel,
            site: this.addBasicinfo.site,
            batterySn: this.addBasicinfo.batterySn,
            fullChargeTime: this.addBasicinfo.fullChargeTime,
            halfV: ''
          }
          param.locationStatus = this.LocatedOrNot == false ? 0 : 1
          param.showAvailableTime = this.addBasicinfo.showAvailableTime == true ? 1 : 0
          param.hourMeterStatus = this.addBasicinfo.hourMeterStatus == true ? 1 : 0
          param.halfV = this.addBasicinfo.halfV == true ? 1 : 0

          var yhubConfig = {
            batteryId: 1,
            batterySystemVolt: 24,
            batteryTotalah: 225,
            canFuntion: this.canFuntion,
            configFrom: 201,
            configVersion: 1,
            extralFuntion: 0,
            gprsApnName: '263.cs101',
            hallDirection: 1,
            hallSensorRange: 1,
            ledSetting: 1,
            locationSample: 60,
            sensorType: 1,
            supportRelaycontrol: 0,
            supportWaterlevel: 0,
            voltClass: 1,
            mcuId: this.addBasicinfo.mcuId,
            nominalCapacity: this.addBasicinfo.c520,
            canopenBaudrate: 2,
            nodeID: 85
          }
          console.log('this.addBasicinfo--', this.addBasicinfo)

          for (var i in yhubConfig) {
            for (var j in this.addBasicinfo) {
              if (i == j && this.addBasicinfo[j]) {
                yhubConfig[i] = this.addBasicinfo[j]
              }
            }
          }
          yhubConfig.configFrom = 201
          yhubConfig.canFuntion = this.canFuntion
          yhubConfig.configVersion = this.addBasicinfo.configVersion ? this.addBasicinfo.configVersion + 1 : 1
          if (this.addBasicinfo.extralFuntion)yhubConfig.extralFuntion = this.addBasicinfo.extralFuntion
          if (this.addBasicinfo.supportRelaycontrol) yhubConfig.supportRelaycontrol = this.addBasicinfo.supportRelaycontrol
          if (this.addBasicinfo.batterySystemVolt) yhubConfig.batterySystemVolt = parseFloat(this.addBasicinfo.batterySystemVolt)
          yhubConfig.batteryTotalah = this.addBasicinfo.batteryTotalah ? parseFloat(this.addBasicinfo.batteryTotalah) * 100 : yhubConfig.batteryTotalah * 100
          if (yhubConfig.batteryId == 0)yhubConfig.batteryId = 2
          if (!yhubConfig.batteryId) {
            this.isShowBatteryModelWarning = true
            return
          }
          if (!this.addBasicinfo.company) {
            this.isShowOwnCompany = true
            return
          }
          if (!this.addBasicinfo.deviceName) {
            this.$message({
              type: 'success',
              message: i18n.t('allDeviceDetail.DeviceNameCannotEmpty')
            })
            return
          }
          /* 如果绑定记录大于1条（包含K、或其它类型），直接调用更新接口。
            如果绑定记录等于1条，先判断是否等于K，等于K直接调用新增接口，否则掉更新接口。
            如果没有绑定记录，直接调用新增接口。  ----2023.2
           */
          if (this.addBasicinfo.bindInfoList.length > 1 || (this.addBasicinfo.bindInfoList.length == 1 && this.bindDeviceTypeArr[0] != 'k')) {
            param.deviceType = this.activeDeviceType.toString()
            updateDeviceBindBase(param).then((response) => {
              if (response.resultCode === 1001) {
                // if (!this.fwversion || Number(this.fwversion) < 200) {
                //   this.$alert(i18n.t('AllDevices.UpdateFailed'), '', {
                //     confirmButtonText: i18n.t('button.Confirm'),
                //     callback: (action) => {}
                //   })
                // } else {
                  this.$notify({
                    title: '',
                    message: i18n.t('BondOrUpdateDevice.BondSucceed'),
                    type: 'success',
                    duration: 2000
                  })
                // }
              } else {
                // this.$message.error(response.resultModel)
                this.$message.error(i18n.t('BondOrUpdateDevice.Failed'))
              }
              // if (this.oldbatterySystemVolt != this.addBasicinfo.batterySystemVolt || this.oldbatteryTotalah != this.addBasicinfo.batteryTotalah) {
              // yhubConfig.batterySystemVolt = this.oldbatterySystemVolt
              // yhubConfig.batteryTotalah = this.oldbatteryTotalah * 100
              addDeviceBindConfig(yhubConfig).then((response) => {})
              this.closePop(this.activeDeviceType)// 提交成功后，列表页要刷新
              // }
            })
          } else {
            // 新增提交时，若sn未被绑定
            addDeviceBindBase(param).then((response) => {
              if (response.resultCode === 1001) {
                // if (!this.fwversion || Number(this.fwversion) < 200) {
                //   this.$alert(i18n.t('AllDevices.UpdateFailed'), '', {
                //     confirmButtonText: i18n.t('button.Confirm'),
                //     callback: (action) => {}
                //   })
                // } else {
                  this.$notify({
                    title: '',
                    message: i18n.t('BondOrUpdateDevice.BondSucceed'),
                    type: 'success',
                    duration: 2000
                  })
                // }
                // console.log('yhubConfig--', yhubConfig)
                addDeviceBindConfig(yhubConfig).then((response) => {})

                getGroupCompanyUserList().then(res => { // 获取登录用户公司旗下的所有用户
                  if (res.resultCode == 1001) {
                    var allUsersName = res.resultModel || []
                    var param = {
                      mcuId: yhubConfig.mcuId,
                      updateById: this.$store.state.userInfo.id,
                      userNameList: []
                    }
                    var companyId = this.$store.state.companyId
                    allUsersName.forEach(v => {
                      if (companyId == v.value) {
                        v.children.forEach(m => {
                          param.userNameList.push(m.label)
                        })
                      }
                    })
                    updatePushMsgUser(param).then(res => {})// 提交推送人
                  }
                })
                this.closePop(this.activeDeviceType)// 提交成功后，列表页要刷新
              } else {
                // this.$message.error(response.resultModel)
                this.$message.error(i18n.t('BondOrUpdateDevice.Failed'))
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleSelect(item) {
    },
    querySearchCity(queryString, cb) { // 获取已有的地址2
      var allCity = this.allCity
      var results = queryString ? allCity.filter(this.createFilter(queryString)) : allCity
      cb(results)
    },
    change(e) {
      this.$forceUpdate()
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    existsOrZero(val) { // 存在或为零则为ture
      if (val && typeof (val) === 'string')val = val.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      if (val === '') {
        return false
      } else if (val || val == 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}

.headContent {
  position: absolute;
  // z-index: 999;
  margin: 0 60px -60px 16px;
  float: left;
  top: 20px;
  width: 100%;
}
.headContent img {
  width: 80px;
}
.headContentQuestion {
  font-size: 22px;
  color: #a5a5a5;
  display: inline-block;
  vertical-align: top;
  margin: 7px 0 0 -5px;
  cursor: pointer;
}
.questionPop {
  display: inline-block;
  background: white;
  padding: 14px;
  vertical-align: top;
  box-shadow: 1px 1px 5px #ccc;
  position: absolute;
  z-index: 999;
  margin: -8px 0 0 -240px;
  width: 30%;
}
.allDevice {
  width: 80px;
  height: 54px;
  line-height: 54px;
  vertical-align: top;
  background: white;
  font-size: 36px;
  color: #1990fc;
  text-align: center;
  border: 1px solid #e6e9edc9;
  border-radius: 3px;
  margin-right: -5px;
}

.formRow {
  display: inline-block;
}
.redWarningRadiu {
  font-size: 20px;
  // margin-top: 5px;
  width: 10px;
  height: 10px;
  display: inline-block;
  position: absolute;
  z-index: 200;
  background: red;
  border-radius: 50%;
  left: calc(50% + 15px);
  top: 0px;
}
.chargeDisBox{
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dcdfe6;
  padding: 15px;
  .attr{
    margin-bottom: 0px!important;
  }
}
.chargeDisWarp{
  display: inline!important;
  .btnWarp{
    text-align: right;
    margin-top: 20px;
    position: relative;
    z-index: 9999;
  }
}
</style>

